import React, { Component } from 'react'

class PDFOrderFooter extends Component {

    render() {
        const { footer, isLabOG } = this.props;
        const numeroPedido = isLabOG && footer.idPedidoOpticlick
            ? `${footer.pedido} e ${footer.idPedidoOpticlick}`
            : footer.pedido;
            
        return (
            <div className="pdf-order-footer row">
                <div className="col-6 text-left">
                    <p>
                        O número do seu pedido no laboratório {footer.laboratorio} é{' '}
                        <small>
                            {footer.pedido}
                        </small>
                        {isLabOG && footer.idPedidoOpticlick && (
                            <>
                                {' '}e <strong>{footer.idPedidoOpticlick}</strong>
                                {' '}<span style={{ fontSize: '12px' }}>(idPedidoOpticlick)</span>
                            </>
                        )}
                    </p>
                </div>
                
                <div className="col-6 text-end">
                    <p style={{ textAlign: 'center' }} className="">
                        A data de saída estimada é{' '}
                        <small className="">
                            {footer.prazo}
                        </small>
                    </p>
                </div>
            </div>
        )
    }
}

export default PDFOrderFooter